import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

async function update(axios: AxiosInstance, dataForEndpoint: any): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/document`, dataForEndpoint);
  return data;
}

export default function useUploadServiceRecordDocumentMutation() {
  const axios = useAxios();

  return useMutation({
    mutationFn: (dataForEndpoint: any) => update(axios, dataForEndpoint),
  });
}
